"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
const function_1 = require("../function");
class TwingExtensionStringLoader extends extension_1.TwingExtension {
    getFunctions() {
        return new Map([
            [0, new function_1.TwingFunction('template_from_string', twingTemplateFromString, { needs_environment: true })],
        ]);
    }
}
exports.TwingExtensionStringLoader = TwingExtensionStringLoader;
/**
 * Loads a template from a string.
 *
 * <pre>
 * {{ include(template_from_string("Hello {{ name }}")) }}
 * </pre>
 *
 * @param {TwingEnvironment} env A TwingEnvironment instance
 * @param {string} template A template as a string or object implementing toString()
 * @param {string} name An optional name for the template to be used in error messages
 *
 * @returns TwingTemplate
 */
function twingTemplateFromString(env, template, name = null) {
    return env.createTemplate(template, name);
}
exports.twingTemplateFromString = twingTemplateFromString;
